import React from 'react'
import { Box } from '@mui/material'
import { TAB_ENDPOINTS } from '../helpers/reportTabs'
import { downloadUserReportCsv } from '../helpers/downloadUserReportCsv'
import DownloadActionButton from '../../../components/action_button/DownloadActionButton'
import ChargesCsvDownloadMenu from './ChargesCsvDownloadMenu'

export default function ReportEffectivenessMobileDownload({
  activeTab,
  startDate,
  endDate,
  searchQuery,
  hasPendingSettlementQuery = ''
}) {
  if (activeTab === 'charges') {
    return (
      <ChargesCsvDownloadMenu
        activeTab={activeTab}
        startDate={startDate}
        endDate={endDate}
        searchQuery={searchQuery}
        hasPendingSettlementQuery={hasPendingSettlementQuery}
      />
    )
  }

  return (
    <Box sx={{ width: '100%' }}>
      <DownloadActionButton
        text="Descargar"
        density="card"
        fullWidth
        onClick={() =>
          downloadUserReportCsv({
            csvType: TAB_ENDPOINTS[activeTab],
            startDate,
            endDate,
            searchQuery,
            activeTabKey: activeTab,
            hasPendingSettlementQuery
          })
        }
      />
    </Box>
  )
}
